/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminRegisterReqBodyDto
 */
export interface AdminRegisterReqBodyDto {
    /**
     * 아이디
     * @type {string}
     * @memberof AdminRegisterReqBodyDto
     */
    'id': string;
    /**
     * 비밀번호
     * @type {string}
     * @memberof AdminRegisterReqBodyDto
     */
    'password': string;
    /**
     * 이름
     * @type {string}
     * @memberof AdminRegisterReqBodyDto
     */
    'name': string;
    /**
     * 어드민 유저 권한
     * @type {Array<string>}
     * @memberof AdminRegisterReqBodyDto
     */
    'adminUserPermissions': Array<AdminRegisterReqBodyDtoAdminUserPermissionsEnum>;
}

export const AdminRegisterReqBodyDtoAdminUserPermissionsEnum = {
    Dashboard: 'dashboard',
    Report: 'report',
    AccountManagement: 'accountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    OperationManagement: 'operationManagement'
} as const;

export type AdminRegisterReqBodyDtoAdminUserPermissionsEnum = typeof AdminRegisterReqBodyDtoAdminUserPermissionsEnum[keyof typeof AdminRegisterReqBodyDtoAdminUserPermissionsEnum];


